import { useQueryState } from 'nuqs';
import { useCallback, useMemo } from 'react';
import { searchParams } from '@/lib/searchparams';

export function useProjectTableFilters() {
  const [searchQuery, setSearchQuery] = useQueryState('q', searchParams.q);
  const [sort, setSort] = useQueryState('sort', searchParams.sort);
  const [organisation, setOrganisation] = useQueryState('organisation', searchParams.organisation); // Reuse company parser
  const [page, setPage] = useQueryState('page', searchParams.page);

  const resetFilters = useCallback(() => {
    setSearchQuery(null);
    setSort(null);
    setOrganisation(null);
    setPage(1);
  }, [setSearchQuery, setSort, setOrganisation, setPage]);

  const isAnyFilterActive = useMemo(() => {
    return !!searchQuery || !!sort || !!organisation;
  }, [searchQuery, sort, organisation]);

  return {
    searchQuery,
    setSearchQuery,
    sort,
    setSort,
    organisation,
    setOrganisation,
    page,
    setPage,
    resetFilters,
    isAnyFilterActive
  };
}
